module.exports = __webpack_public_path__ + "museosans_500-webfont.d6dac2ab6ace1e1a5a97.woff";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/museosans_500-webfont.woff
// module id = ../../../../../src/assets/fonts/museosans_500-webfont.woff
// module chunks = styles